module.exports = __webpack_public_path__ + "static/media/YM90_7.78d344ba.jpg";